import React from "react"

export default class SuccessCheckmark extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="success-checkmark">
				<label>
					<div className="check"></div>
				</label>
			</div>
		)
	}

}